import { Button } from '@cian/ui-kit';
import * as React from 'react';

import { DEFAULT_CALLBACK_CONTENT } from '../../../../constants/callback';
import { TCallBackButtonComponent } from '../../types';

export const CallbackButton: TCallBackButtonComponent = ({ size, onClick }) => {
  const { buttonText } = DEFAULT_CALLBACK_CONTENT;

  return (
    <Button onClick={onClick} theme="fill_secondary" size={size} fullWidth>
      {buttonText}
    </Button>
  );
};
